<template>
	<div class="content">
		<div class="modal" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h3 v-if="tradingType == 'kinesis'" class="modal-title" id="exampleModalLabel">BULLION WITHDRAWAL (KAU)</h3>
						<h3 v-else class="modal-title" id="exampleModalLabel">BULLION WITHDRAWAL</h3>
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true">
							<i class="tim-icons icon-simple-remove"></i>
						</button>
					</div>
					<div class="modal-body">
						<div class="alert alert-warning fade show" role="alert">
							No holdings are available for withdrawal in this marketplace for this account. 
							<button type="button" class="close" data-dismiss="alert" aria-label="Close">
								<i class="tim-icons icon-simple-remove"></i>
							</button>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-success">Transfer</button>
					</div>
				</div>
			</div>
		</div>
		<ul class="nav nav-pills nav-pills-primary justify-content-center" role="tablist">
			<li class="nav-item">
				<a class="nav-link active" data-toggle="tab" href="#link1" role="tablist" aria-expanded="true">
					Cash
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#link2" role="tablist" aria-expanded="false">
					Credit
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#link3" role="tablist" aria-expanded="false">
					Bullion
				</a>
			</li>
			<li class="nav-item">
				<a id="track-bullion" class="nav-link" data-toggle="tab" href="#link4" role="tablist" aria-expanded="false">
					Track Bullion
				</a>
			</li>
		</ul>

		<div class="tab-content tab-space">

			<!-- Cash -->
			<div class="tab-pane active" id="link1" aria-expanded="true">
				<!-- <div id="myProgress">
					<div id="myBar">
					</div>
					<div id="frontBar">
						10.00
					</div>
				</div> -->
				<!-- <button @click="move()">Click Me</button> -->
				<div class="row">
					<div v-if=" paymentInformationStatus == 'loading' " class="col-sm-12 col-lg-6 text-center mb-4">
						<Loader
							size_prop = '10em'
						></Loader>
					</div>
					<div v-else class="col-sm-12 col-lg-6 text-center">
						<!-- <template v-if="payrefDisplay == 'initial'"> -->
						<template>
							<h4 v-if="payrefDisplay == 'initial'">COMMODITY ACCOUNT (APED)</h4>
							<h4 v-else>DEPOSIT TO BANK ACCOUNT</h4>
							<dl class="row text-left">
								<dt class="col-4 offset-2">BANK NAME</dt>
								<dd class="col-6">Bank Artha Graha Internasional</dd>

								<dt class="col-4 offset-2">BSB/BANK CODE</dt>
								<dd class="col-6">037</dd>

								<dt class="col-4 offset-2">ACCOUNT NUMBER</dt>
								<dd v-if="payrefDisplay == 'initial'" class="col-6">108{{ randAccountNumberAped }}</dd>
								<dd v-else class="col-6">108{{ randAccountNumber }}</dd>

								<dt class="col-4 offset-2">ACCOUNT NAME</dt>
								<dd class="col-6">{{ firstName }}</dd>

								<dt class="col-4 offset-2">BANK ADDRESS</dt>
								<dd class="col-6">Gedung Artha Graha, Jl. Jend. Sudirman Kav. 52 - 53 Jakarta Selatan -12190</dd>

								<dt class="col-4 offset-2" :style="{display: payrefDisplay}">PAYMENT REFERENCE</dt>
								<dd class="col-6" :style="{display: payrefDisplay}">{{this.$store.getters.getHin}}</dd>
							</dl>
						</template>
						<!-- <template v-else>
							<h4>DEPOSIT TO BANK ACCOUNT</h4>
							<dl class="row text-left">
								<dt class="col-4 offset-2">BANK NAME</dt>
								<dd class="col-6">{{((paymentInfo || '-').utility_account[utilityAccountIndex] || '-').bank_name || '-'}}</dd>

								<dt class="col-4 offset-2">BSB/BANK CODE</dt>
								<dd class="col-6">{{((paymentInfo || '-').utility_account[utilityAccountIndex] || '-').bank_code || '-'}}</dd>

								<dt class="col-4 offset-2">ACCOUNT NUMBER</dt>
								<dd class="col-6">{{((paymentInfo || '-').utility_account[utilityAccountIndex] || '-').account_number || '-'}}</dd>

								<dt class="col-4 offset-2">ACCOUNT NAME</dt>
								<dd class="col-6">{{((paymentInfo || '-').utility_account[utilityAccountIndex] || '-').account_name || '-'}}</dd>

								<dt class="col-4 offset-2">BANK ADDRESS</dt>
								<dd class="col-6">{{((paymentInfo || '-').utility_account[utilityAccountIndex] || '-').bank_address || '-'}}</dd>

								<dt class="col-4 offset-2" :style="{display: payrefDisplay}">PAYMENT REFERENCE</dt>
								<dd class="col-6" :style="{display: payrefDisplay}">{{this.$store.getters.getHin}}</dd>
							</dl>
						</template> -->
					</div>

					<div class="col-sm-12 col-lg-6 col text-center">
						<div class="tab-content">
							<div class="tab-pane active" id="nav2-link1" aria-expanded="false">
								<h4>CASH TRANSACTION HISTORY</h4>
							</div>
							<div class="tab-pane" id="nav2-link2" aria-expanded="true">
								<h4>WITHDRAW CASH INTO TRADING ACCOUNT</h4>
							</div>
						</div>
						<ul class="nav nav-pills nav-pills-default nav-justified" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" data-toggle="tab" href="#nav2-link1" role="tablist" aria-expanded="true" @click="showDeposit">
									Last 10 Transaction
								</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" data-toggle="tab" href="#nav2-link2" role="tablist" aria-expanded="false" @click="showWithdraw">
									Withdraw
								</a>
							</li>
						</ul>

						<hr>

						<div class="row mb-0" style="color: rgb(255, 255, 255, 0.8);">
							<div class="col-6 text-right">
								<b>US ${{availableTradeBalanceUsd}}</b>
							</div>
							<div class="col-6 text-left">
								<b>IDR {{availableTradeBalanceIdr}}</b>
							</div>
						</div>
						<p>AVAILABLE WITHDRAW BALANCE</p>
						<br>
						<div id="deposit" :style="{ display: depositDisplay }">
							<table class="table table-striped">
								<thead>
									<tr>
										<th scope="col">DATE</th>
										<th scope="col">DEBIT</th>
										<th scope="col">CREDIT</th>
									</tr>
								</thead>
								<tbody>
									<template v-if="balanceHistory.length > 0">
										<tr v-for="(item, index) in balanceHistory" :key="index">
											<td>{{item.date}}</td>
											<td>{{item.debit}}</td>
											<td>{{item.credit}}</td>
										</tr>
									</template>
									<template v-else>
										<tr>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
										</tr>
									</template>
								</tbody>
							</table>
						</div>
						<div id="withdraw" :style="{ display: withdrawDisplay }">
							<form @submit.prevent="reqWithdrawal()">
								<div class="form-group row">
									<label for="paymentUtilityBankName" class="col-auto col-form-label">To</label>
									<div v-if="paymentInfo" class="col-auto text-left">
										<!-- <button class="btn px-3" type="button" @click="showWithdrawDestination()">
											<img v-if="withdrawDestinationLogo != ''" :src="withdrawDestinationLogo" style="height: auto; width: 30px;">
											<span class="d-inline mx-3 text-uppercase">{{withdrawDestination}}</span>
										</button> -->
										
										<div class="btn-group dropright">
											<button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuWithdrawDestination" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<img v-if="withdrawDestinationLogo != ''" :src="withdrawDestinationLogo" style="height: auto; width: 30px;">
												<span class="d-inline mx-3 text-uppercase">{{withdrawDestination}}</span>
											</button>
											<div v-if="this.$store.state.bankType != 'BAGI'" class="dropdown-menu" aria-labelledby="dropdownMenuWithdrawDestination">
												<span class="dropdown-item-text text-white">BANK</span>
												<button :class="['dropdown-item', withdrawDestination == 'cimb' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('cimb')">
													<img :src="`${publicPath}assets/img/logo-cimb-3.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">CIMB Niaga</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'bca' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('bca')">
													<img :src="`${publicPath}assets/img/logo-bca-2.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">BCA</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'mandiri' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('mandiri')">
													<img :src="`${publicPath}assets/img/logo-mandiri-3.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Mandiri</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'bni' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('bni')">
													<img :src="`${publicPath}assets/img/logo-bni-2.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">BNI</span>
												</button>

												<div class="dropdown-divider"></div>

												<span class="dropdown-item-text">E-WALLET</span>
												<button :class="['dropdown-item', withdrawDestination == 'giropos' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('giropos')">
													<img :src="`${publicPath}assets/img/pos-giro.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Giropos</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'rekpon' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('rekpon')">
													<img :src="`${publicPath}assets/img/logo-cimb-3.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Rekpon</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'ovo' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('ovo')">
													<img :src="`${publicPath}assets/img/logo-ovo-3.jpg`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Ovo</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'gopay' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('gopay')">
													<img :src="`${publicPath}assets/img/logo-gopay-2.jpg`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Gopay</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'linkaja' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('linkaja')">
													<img :src="`${publicPath}assets/img/logo-linkaja.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Linkaja</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'dana' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('dana')">
													<img :src="`${publicPath}assets/img/logo-dana-2.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Dana</span>
												</button>
												<button :class="['dropdown-item', withdrawDestination == 'isaku' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('isaku')">
													<img :src="`${publicPath}assets/img/logo-isaku.jpg`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Isaku</span>
												</button>
												<!-- <button class="dropdown-item" type="button">Another action</button>
												<button class="dropdown-item" type="button">Something else here</button> -->
											</div>
											<div v-else class="dropdown-menu" aria-labelledby="dropdownMenuWithdrawDestination">
												<span class="dropdown-item-text text-white pl-3">BANK</span>
												<button :class="['dropdown-item', withdrawDestination == 'Artha Graha' ? 'active' : '' ]" type="button" @click="withdrawDestinationAfterClose('Artha Graha')">
													<img :src="`${publicPath}assets/img/logo-bagi-removebg.png`" style="height: 30px; width: auto;">
													<span class="d-inline mx-3 text-uppercase">Artha Graha</span>
												</button>
											</div>
										</div>

										<!-- <a v-if="withdrawDestinationLogo != ''" class="ml-3" style="color: #4f7bff; text-decoration: underline;" href="#" @click.prevent="showWithdrawDestination">Change...</a> -->
										<!-- <select class="custom-select" style="width: initial;" v-model="utilityAccountIndex">
											<option v-for="(item, index) of paymentInfo.utility_account" :key="item.bank_name" :value="index">{{item.bank_name}}</option>
										</select> -->
									</div>
								</div>
								
								<div v-show="showPhoneNumber" class="form-group row mb-3">
									<label for="phoneNumber" class="col-auto form-control-md col-form-label">{{labelWithdraw}}</label>
									<div class="col">
										<input type="text" class="form-control c-disabled" id="phoneNumber" v-model="withdrawDestinationAccountNumber" disabled>
									</div>
								</div>

								<div class="input-group mb-1">
									<div class="input-group-prepend">
										<span class="input-group-text">US $</span>
									</div>
									<input type="text" class="form-control c-hide-spinner" v-model.number="withdrawUsdInInput">
									<div class="input-group-append">
										<span class="c-decrease-button input-group-text" @click="decreaseWithdrawUsd">-</span>
										<span class="c-increase-button input-group-text" @click="increaseWithdrawUsd">+</span>
									</div>
								</div>
								<small v-for="item in withdrawUsdError" :key="'error' + item" class="c-text-danger float-left font-weight-bold mb-3" style="padding-left: 9px">{{item}}</small>

								<div class="input-group my-3">
									<div class="input-group-prepend">
										<span class="input-group-text">IDR</span>
									</div>
									<input type="text" class="form-control" v-model.number="withdrawIdrInInput">
									<div class="input-group-append">
										<span class="c-decrease-button input-group-text" @click="decreaseWithdrawIdr">-</span>
										<span class="c-increase-button input-group-text" @click="increaseWithdrawIdr">+</span>
									</div>
								</div>

								<div class="form-group">
									<textarea class="form-control" placeholder="Optional description" rows="5" style="max-height: 200px;" v-model="withdrawDescription"></textarea>
								</div>
								<hr>
								<button type="submit" class="btn btn-success">WITHDRAW</button>
							</form>
						</div>
					</div>
				</div>
			</div>

			<!-- Credit -->
			<div class="tab-pane" id="link2" aria-expanded="false">
				<div class="row justify-content-center">
					<div class="col-12 col-md-7 col-lg-5 text-center">
						<h4 v-if="tradingType == 'kinesis'">CREDIT DETAILS (KAU)</h4>
						<h4 v-else>CREDIT DETAILS</h4>
						<div class="row" style="color: rgb(255, 255, 255, 0.8);">
							<div class="col-6 text-right">
								<b>US $0.00</b>
							</div>
							<div class="col-6 text-left">
								<b>IDR 0.00</b>
							</div>
						</div>
						<div class="row mb-1">
							<div class="col">
								<p>AVALAIBLE CREDIT</p>
							</div>
						</div>
						<div class="row mb-0" style="color: rgb(255, 255, 255, 0.8);">
							<div class="col-6 text-right">
								<b>US $0.00</b>
							</div>
							<div class="col-6 text-left">
								<b>IDR 0.00</b>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<p>CREDIT LIMIT</p>
							</div>
						</div>
						<hr>
						<h4>REQUEST NEW CREDIT LIMIT</h4>
						<div class="row">
							<div class="col">
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text">US $</span>
									</div>
									<input type="number" class="form-control c-hide-spinner" v-model="reqCreditLimitUSD">
									<div class="input-group-append">
										<span class="c-decrease-button input-group-text" @click="decreaseReqCreditLimit">-</span>
										<span class="c-increase-button input-group-text" @click="increaseReqCreditLimit">+</span>
									</div>
								</div>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text">IDR</span>
									</div>
									<input type="number" class="form-control c-hide-spinner" v-model="reqCreditLimitIDR" readonly>
								</div>
								<div class="form-group">
									<textarea class="form-control" placeholder="Optional description" rows="5" style="max-height: 200px;"></textarea>
								</div>
								<hr>
								<button type="button" class="btn btn-success px-3" @click="reviewCreditChange()"><i class="tim-icons icon-check-2"></i>&ensp;REVIEW CREDIT CHANGE REQUEST</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Bullion -->
			<div class="tab-pane" id="link3" aria-expanded="false">
				<div class="row">
					<div class="col-12">
						<div class="card px-2">
							<div class="card-header">
								<!-- <h4 class="card-title">WITHDRAWAL DETAILS - FROM</h4> -->
							</div>
							<div class="card-body">
								<form @submit.prevent="submitBullionWithdrawal()">
									<div class="row">
										<div class="col">

											<div class="row" style="max-width: 90ch;">
												<div class="col">
													<div class="row flex-nowrap">
														<div class="col-auto" style="min-width: 152px;">
															<div class="mb-4">Customer</div>
															<div class="mb-4">Account ID</div>
														</div>
														<div class="col text-nowrap">
															<div class="text-left mb-4">: <span class="text-white">{{firstName}}</span></div>
															<div class="text-left mb-4">: <span class="text-white">{{hin}}</span></div>
														</div>
													</div>
												</div>

												<div class="col-auto">
													<div class="row">
														<div class="col-auto" style="min-width: 152px;">
															<div class="mb-4">Order Date</div>
															<div class="mb-4">Arrival Date (est.)</div>
														</div>
														<div class="col-auto">
															<div class="text-left mb-4">: <span class="text-white">{{ dateToday }}</span></div>
															<div class="text-left mb-4">: <span class="text-white">{{ arrivalDate }}</span></div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="w-100"></div>

										<div class="col-12 col-md-auto py-2">
											<span>Pick Up Location</span>
										</div>

										<div class="col" style="max-width: 75ch;">
											<template v-if="apiStatusGetPostalCode == 'loading'">
												<Loader
													size_prop = "2em"
												></Loader>
											</template>
											<template v-else>
												<input list="locations" name="location" id="location" class="form-control mb-3" style="font-size: 0.875rem;" v-model="destination" placeholder="Choose location" required>
												<datalist id="locations">
													<template v-for="location in locations">
														<option :key="location.location_id" :value="location.location_name" :label="`${location.address}`"></option>
													</template>
												</datalist>
											</template>
										</div>

									</div>
								</form>
							</div>
						</div>
					</div>

					<div class="col-12">
						<div class="card px-2">
							<div class="card-header">
								<h3 class="mb-3">Description</h3>
							</div>

							<div class="card-body">
								<div class="row justify-content-center justify-content-md-start">
									
									<div class="col-12 col-md-6" style="max-width: 60ch;">
										<div class="ml-2">
											<div class="row text-white bg-dark rounded text-nowrap mb-3 mr-md-4 py-2" style="max-width: 60ch;">
												<div class="col-12">
													<h4 class="mb-2">Holdings</h4>
												</div>
												<div class="col text-white">
													<template v-for="item in totalGold">
														<div :key="'holding1' + item.contractId" v-if="item.status != 'disabled'" class="mb-2">{{ item.product }}</div>
													</template>
												</div>
												<div class="col text-right text-white">
													<template v-for="item in totalGold">
														<div :key="'holding2' + item.contractId" v-if="item.status != 'disabled'" class="mb-2">{{ item.totalGram }} gram ({{ item.quantity }})</div>
													</template>
												</div>
											</div>
										</div>

										<div>
											<div class="row text-white mb-5 mr-md-3" style="max-width: 60ch;">
												<div class="col-12">
													<h4 class="mb-2">Withdraw Quantity</h4>
												</div>
												<div class="col">
													<template v-for="item in totalGold">
														<div :key="'withdraw1' + item.contractId" v-if="item.status != 'disabled'" class=" mb-3" style="padding: 3.45px 0px;">{{ item.product }}</div>
													</template>
												</div>
												<div class="col-auto">
													<template v-for="item in totalGold">
														<div :key="'withdraw2' + item.contractId" v-if="item.status != 'disabled'">
															<div class="float-right c-input-field mb-3">
																<button class="button button-counter decrease" @click="decreaseQuantityInt(item.contractId)">-</button>
																<input class="c-input number-font" type="text" :name="`bullionWithdrawalQuantity${ item.contractId }`" v-model="bullionWithdrawalQuantity[item.contractId]">
																<button class="button-counter increase" @click="increaseQuantityInt(item.contractId)">+</button>
															</div>
														</div>
													</template>
												</div>
											</div>
										</div>

									</div>

									<div class="col-12 col-md-6" style="max-width: 60ch;">
										<div class="row text-nowrap">
											<div class="col-auto">
												<div class="mb-4">Weight</div>
												<div class="mb-4">Quantity</div>
												<div class="mb-4">Value Goods</div>
											</div>
											<div class="col pr-0">
												<div class="text-right mb-4"><span class="text-white">{{ bullionWithdrawalTotalWeightShown }}</span></div>
												<div class="text-right mb-4"><span class="text-white">{{ bullionWithdrawalTotalQuantityShown }}</span></div>
												<div class="text-right mb-4"><span class="text-white">Rp {{ valueGoodsShown }}</span></div>
											</div>
											<div class="col-auto pl-0">
												<div class="mb-4 text-left"><pre class="d-inline"> </pre>gram</div>
												<div class="mb-4 text-left"><pre class="d-inline"> </pre>bars </div>
											</div>
										</div>
										
										<div class="border c-border-white rounded px-3 py-2 mb-3" id="description" v-html="bullionWithdrawalDescriptionShown"></div>
										
									</div>

								</div>
							</div>
						</div>
					</div>

					<div class="col-12">
						<div class="card px-2">
							<div class="card-header">
								
							</div>
							<div class="card-body px-0 px-md-3">

								<div class="container px-md-0 ml-md-0" style="max-width: 60ch;">
									<div class="mb-3">
										<span class="text-left">Delivery Cost</span>
										<div class="text-right float-right text-white number-font">Rp {{ deliveryCostInInput }}</div>
									</div>

									<div class="mb-3">
										<span class="text-left">Insurance</span>
										<div class="text-right float-right text-white number-font">Rp {{ insuranceInInput }}</div>
									</div>

									<div class="mb-3">
										<span class="text-left">Duty, Taxes, & Customs</span>
										<div class="text-right float-right text-white number-font">Rp {{ taxAndCustoms }}</div>
									</div>

									
								</div>
							</div>
						</div>
					</div>

					<div class="col-12 sticky">
						<div class="card px-2 mb-0" style="box-shadow: 0px 0px 2px white;">
							<!-- <div class="card-header">
								
							</div> -->
							<div class="card-body">
								<div class="row">
									
									<div class="col">
										<div class="">
											<h4 class="m-0">Total Charges</h4>
											<div class="number-font text-gold" style="font-size: 2rem;">Rp {{ bullionWithdrawalTotalChargesInInput }}</div>
										</div>
									</div>

									<div class="col">
										<div class="float-right">
											<template v-if="apiStatusGetFee == 'loading'">
												<Loader
													size_prop = '5em'
												></Loader>
											</template>
											<template v-else>
												<button v-if="!isBullionWithdrawalTotalChargesCounted" class="btn c-btn-warning" type="button" @click="countTotalCharges()">Count Total Charges</button>
												<button v-else type="button" class="btn btn-lg w-100 c-btn-success" @click="submitBullionWithdrawal()">Submit</button>
											</template>
											<br>
											<div style="max-width: 60ch;">

												<a href="javascript:void(0)" class="text-light" @click="showDisclaimer()">
													<i v-if="!disclaimerHasBeenRead" class="far fa-circle"></i>
													<i v-else class="far fa-check-circle" :style="{color: '#2ec4b6'}"></i>
													Please read our <a href="javascript:void(0)" class="text-white font-weight-bold">Disclaimer</a> first
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
			
			<!-- Track Bullion -->
			<div class="tab-pane" id="link4" aria-expanded="false">
				<div class="row">
					<div class="col-12">
						<TrackBullion
							ref = "trackBullion"
						>
						</TrackBullion>
					</div>
				</div>
			</div>
		</div>

		<Disclaimer
			v-show = "disclaimerIsOpen"
			@close = "disclaimerAfterClose"
		>
		</Disclaimer>
	</div>
</template>

<script>
	import axios from 'axios'
	import Swal from 'sweetalert2'
	import {Decimal} from 'decimal.js'

	import Loader from '@/components/Loader.vue'
	import TrackBullion from '@/components/TrackBullion.vue'
	import Disclaimer from '@/components/Disclaimer.vue'

	export default {
		name: 'Transfer',
		components: {
			Loader,
			TrackBullion,
			Disclaimer
		},
		data() {
			const dateTodayIso = new Date(Date.now())
			const month = ['month', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
			return {
				dateToday: `${dateTodayIso.getDate()} ${month[dateTodayIso.getMonth()]} ${dateTodayIso.getFullYear()}`,
				arrivalDate: `${dateTodayIso.getDate() + 7} ${month[dateTodayIso.getMonth()]} ${dateTodayIso.getFullYear()}`,

				publicPath: process.env.BASE_URL,

				depositUsd: 0,

				withdrawUsd: 0,
				withdrawIdr: 0,
				withdrawDescription: '',

				reqCreditLimitUSD: 0,
				depositDisplay: 'block',
				withdrawDisplay: 'none',
				payrefDisplay: 'initial',
				balanceHistory: [],
				withdrawUsdError: [],
				paymentInfo: null,
				utilityAccountIndex: 1,
				paymentInformationStatus: 'idle',

				bullionWithdrawalOrder: [626],
				bullionWithdrawalQuantity: {
					"626": 0,
					// "264": 0,
					// "633": 0,
					// "271": 0,
				},
				bullionWithdrawalMultiple: {
					"626": 10,
					// "264": 10,
					// "633": 10,
					// "271": 10,
				},
				totalGold: [],
				withdrawDestination: 'CHOOSE...',
				withdrawDestinationLogo: '',
				withdrawDestinationIsOpen: false,

				withdrawDestinationAccountNumber: '',

				bullionWithdrawalOrderDate: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0,10),
				bullionWithdrawalArrivalDate: '',
				bullionWithdrawalTime: '00:00',

				locations: [],
				destination: '',
				postalCode: [],
				isBullionWithdrawalTotalChargesCounted: true,

				disclaimerIsOpen: false,
				disclaimerHasBeenRead: false,
				checkColor: 'grey',

				apiStatusGetPostalCode: 'idle',
				apiStatusGetFee: 'idle',

				feeGetFee: 0,
				feeTaxGetFee: 0,
				insuranceGetFee: 0,
				insuranceTaxGetFee: 0,
			}
		},
		computed: {
			hin() {
				return this.$store.getters.getHin
			},
			firstName() {
				return this.$store.getters.getFirstName
			},
			gold100gr() {
				return this.$store.getters.goldById(1)
			},
			streamingRate() {
				return this.$store.getters.getStreamingRate
			},
			currency() {
				return this.$store.state.currency
			},

			products() {
				return this.$store.state.products
			},
			holdings() {
				return this.$store.state.holdings
			},

			randAccountNumber() {
				const max = 10000000//excluded
				const min = 100000//excluded

				let temp = Math.floor(Math.random() * (max - min) ) + min
				if (temp < 1000000) {
					temp = `0${temp}`
				}

				return temp
			},

			randAccountNumberAped() {
				const max = 10000000//excluded
				const min = 100000//excluded

				let temp = Math.floor(Math.random() * (max - min) ) + min
				if (temp < 1000000) {
					temp = `0${temp}`
				}

				return temp
			},

			tradingType() {
				return this.$store.state.tradingType
			},
			availableTradeBalanceUsd() {
				return this.numberFormat(this.$store.state.availableTradeBalanceUsd.toFixed(2))
			},
			availableTradeBalanceIdr() {
				return this.numberFormat(this.$store.state.availableTradeBalanceIdr.toFixed(2))
			},

			showPhoneNumber() {
				if (this.withdrawDestination != 'giropos' && this.withdrawDestination != '' && this.withdrawDestination != 'CHOOSE...') {
					return true
				} else {
					return true
				}
			},
			labelWithdraw() {
				let temp = 'Account Number'
				switch (this.withdrawDestination) {
					case 'cimb':
					case 'bca':
					case 'mandiri':
					case 'bni':
					case 'Artha Graha':
						temp = 'Account Number'
						break;
					case 'giropos':
					case 'rekpon':
					case 'ovo':
					case 'gopay':
					case 'linkaja':
					case 'dana':
					case 'isaku':
						temp =	'Phone Number / ID'
						break;
					default:
						temp = 'Account Number'
				}
				return temp
			},

			withdrawUsdInInput: {
				get: function() {
					return Number(this.withdrawUsd.toFixed(2))
				},
				set: function(newValue) {
					this.withdrawUsd = newValue
					this.withdrawIdr = newValue * this.streamingRate.streamBuy
				}
			},
			withdrawIdrInInput: {
				get: function() {
					return Number(this.withdrawIdr.toFixed(0))
				},
				set: function(newValue) {
					this.withdrawIdr = newValue
					this.withdrawUsd = newValue / this.streamingRate.streamBuy
				}
			},

			reqCreditLimitIDR() {
				return this.reqCreditLimitUSD * this.streamingRate.streamBuy
			},
			utilityBankName: {
				get: function() {
					return this.utilityAccountIndex
				},
				set: function(val) {
					this.utilityAccountIndex == val
				}
			},

			bullionWithdrawalTotalWeight() {
				let sum = 0
				let bullionWithdrawalQuantity = this.bullionWithdrawalQuantity
				for( const item in bullionWithdrawalQuantity ) {
					if (this.products) {
						const contractConfig = this.$store.getters.contractConfigByContractId(item)
						console.log('WETWETWET', contractConfig)
					// let product = this.products.find(obj => obj.id == item)
						sum = Decimal.mul(bullionWithdrawalQuantity[item], contractConfig.weightInGram).add(sum)
					}
				}

				return Number(sum)
			},
			bullionWithdrawalTotalWeightShown() {
				let sum = 0
				let bullionWithdrawalQuantity = this.bullionWithdrawalQuantity
				for( const item in bullionWithdrawalQuantity ) {
					if (this.products) {
						const contractConfig = this.$store.getters.contractConfigByContractId(item)
						sum = Decimal.mul(bullionWithdrawalQuantity[item], contractConfig.weightInGram).add(sum)
					}	
				}

				return Number(sum)
			},

			bullionWithdrawalTotalQuantity() {
				let sum = 0
				let bullionWithdrawalQuantity = this.bullionWithdrawalQuantity
				for( const item in bullionWithdrawalQuantity ) {
					sum = Decimal.add(sum, this.bullionWithdrawalQuantity[item])
				}

				return Number(sum)
			},
			bullionWithdrawalTotalQuantityShown() {
				let sum = 0
				let bullionWithdrawalQuantity = this.bullionWithdrawalQuantity
				for( const item in bullionWithdrawalQuantity ) {
					sum = Decimal.add(sum, bullionWithdrawalQuantity[item])
				}

				return Number(sum)
			},

			valueBullionWithdrawal() { //value goods
				let temp = this.gold100gr
				if (temp) {
					if (temp.sell >= 0) {
						return Number(Decimal.mul(this.bullionWithdrawalTotalWeight, temp.sell).mul(this.streamingRate.streamSell))
					}else {
						return 0
					}
				}else {
					return 0
				} 
			},

			insurance() {
				const temp = Number(this.insuranceGetFee).toFixed(2)
				if (temp) {
					return temp
				}else {
					return 0
				}
			},
			insuranceInInput() {
				if (this.isBullionWithdrawalTotalChargesCounted) {
					return this.numberFormat(this.insurance)
				}else {
					return '-'
				}
			},

			valueGoods() {
				return Number((this.valueBullionWithdrawal).toFixed(2))
			},
			valueGoodsShown() {
				return this.numberFormat(this.valueGoods)
			},

			bullionWithdrawalDescription() {
				return `Emas batangan (Gold Bar LBMA 999.9) seberat ${this.bullionWithdrawalTotalWeightShown} gram sejumlah ${this.bullionWithdrawalTotalQuantityShown} batang`
			},

			bullionWithdrawalDescriptionShown() {
				return `Emas batangan (Gold Bar LBMA 999.9) seberat <b class="text-white text-nowrap">${this.bullionWithdrawalTotalWeightShown} gram</b> sejumlah <b class="text-white text-nowrap">${this.bullionWithdrawalTotalQuantityShown} batang</b>`
			},

			selectedDestination() {
				if (this.locations.length > 0) {
					let temp = this.locations.find(obj => obj.location_name == this.destination)
					return temp
				}
				return null
			},

			deliveryCost() {
				return this.feeGetFee
			},
			deliveryCostInInput() {
				if (this.isBullionWithdrawalTotalChargesCounted) {
					return this.numberFormat(this.deliveryCost)
				}else {
					return '-'
				}
			},

			taxAndCustoms() {
				if (this.isBullionWithdrawalTotalChargesCounted) {
					return Number((this.feeTaxGetFee + this.insuranceTaxGetFee).toFixed(2))
				}else {
					return '-'
				}
			},

			bullionWithdrawalTotalCharges() {
				return Number((this.feeGetFee + this.insuranceGetFee + this.feeTaxGetFee + this.insuranceTaxGetFee).toFixed(2))
			},
			bullionWithdrawalTotalChargesInInput() {
				if (this.isBullionWithdrawalTotalChargesCounted) {
					return this.numberFormat(this.bullionWithdrawalTotalCharges)
				}else {
					return '-'
				}
			},

		},
		
		watch: {
			currency() {
				this.balanceHistory = []
				this.getDepositWithdrawalHistory()
			},

			selectedDestination() {
				this.isBullionWithdrawalTotalChargesCounted = true
			},

			bullionWithdrawalTotalWeightShown() {
				this.isBullionWithdrawalTotalChargesCounted = true

				let tempFeeGetFee = Number(Decimal.ceil(this.bullionWithdrawalTotalWeight).mul(10000))
				this.feeGetFee = (this.bullionWithdrawalTotalWeight > 0 && this.bullionWithdrawalTotalWeight < 1) ? 10000 : tempFeeGetFee

				this.feeTaxGetFee = Number(Decimal.mul(this.feeGetFee, 0.1))
				this.insuranceGetFee = Number(Decimal.mul(this.valueGoods, 0.01))
				this.insuranceTaxGetFee = Number(Decimal.mul(this.insuranceGetFee, 0.1))
			},

			disclaimerHasBeenRead(newValue) {
				if (newValue) {
					this.checkColor = 'lightgreen'
				}else {
					this.checkColor = 'grey'
				}
			}
		},

		beforeCreate() {
			// this.$store.dispatch('setHoldings')
		},

		created() {
			const firstCall = setInterval(() => {
				if (this.products && this.holdings) {
					clearInterval(firstCall)

					this.setBullionWithdrawal()
				}
			}, 1000)

			for(let el in this.bullionWithdrawalQuantity) {
				this.$watch(`bullionWithdrawalQuantity.${el}`, function (newValue) {
					if (!newValue || isNaN(newValue)) {
						this.bullionWithdrawalQuantity[el] = 0
						return 0
					}
					newValue = Number(newValue)

					const product = this.products.find(obj => obj.id == el)
					const holding = this.holdings.find(obj => obj.attributes.contractId == el)
					const totalGram = Number(Decimal.mul(product.attributes.weightInGram, Decimal.div(holding.attributes.value, product.attributes.weightCorrection)))
					let temp = new Decimal(newValue)

					if (temp.greaterThan(totalGram)) {
						// this.bullionWithdrawalQuantity[el] = Number(Decimal.mod(totalGram, this.bullionWithdrawalMultiple[el]).sub(totalGram))
						this.bullionWithdrawalQuantity[el] = totalGram
					}else if (temp.lessThan(0)) {
						this.bullionWithdrawalQuantity[el] = 0
					}else {
						this.bullionWithdrawalQuantity[el] = Number(temp)
					}
				}, {deep:true})
			}

			// for (let i = 0; i < this.bullionWithdrawalOrder.length; i++) {
			// 	let temp = (this.bullionWithdrawalOrder[i] == 7) ? 100 : 10
			// 	this.$set(this.bullionWithdrawalQuantity, (this.bullionWithdrawalOrder[i]), 0)
			// 	this.$set(this.bullionWithdrawalMultiple, (this.bullionWithdrawalOrder[i]), temp)
			// }
			// this.bullionWithdrawalQuantity['7'] = 0
			// this.bullionWithdrawalQuantity['5'] = 0
			// this.bullionWithdrawalQuantity['1'] = 0
			// this.bullionWithdrawalQuantity['3'] = 0

			this.utilityAccountIndex = (this.$store.state.bankType == "BAGI") ? 1 : 0		

			axios({
				method: 'get',
				url: process.env.VUE_APP_BACKEND_URL+'/abx/metals',
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('token')
				}
			}).then(function (response) {
				console.log('berhasil metals', response)
			}).catch(error => {
				console.log("gagal metals", error)
			})

			this.getDepositWithdrawalHistory()

			this.paymentInformationStatus = 'loading'
			axios({
				method: 'get',
				url:process.env.VUE_APP_BACKEND_URL+'/abx/payment_information'
			}).then(response => {
				this.paymentInfo = response.data.data
				this.paymentInformationStatus = 'success'
				console.log('berhasil payment information', response)
			}).catch(error => {
				this.paymentInformationStatus = 'error'
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request);
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message);
				}
				console.log('gagal payment information', error.config);
			})

			axios({
				method: 'get',
				url: process.env.VUE_APP_BACKEND_URL+'/get/location',
			}).then((response) => {
				let data = response.data.data.filter(obj => obj.active == true)

				this.locations = data.sort((a, b) => {
					let nameA = a.location_name.toUpperCase() // ignore upper and lowercase
					let nameB = b.location_name.toUpperCase() // ignore upper and lowercase
					if (nameA < nameB) {
						return -1
					}
					if (nameA > nameB) {
						return 1
					}

					// names must be equal
					return 0
				})
				console.log('berhasil location', response, data)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request);
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message);
				}
				console.log('gagal location', error.config);
			})
		},
		methods: {
			move() {
				let i = 0
				if (i == 0) {
					i = 1
					let elem = document.getElementById("myBar")
					let elem2 = document.getElementById("frontBar")
					let width = 0
					let time = 10
					let id = setInterval((() => {
						if (width >= 100) {
							clearInterval(id)
							i = 0
						} else {
							width += 0.1
							time -= 0.01
							elem.style.width = width + "%"
							elem2.innerHTML = time.toFixed(2)	+ ""
						}
					}), 10)
				}
			},
			numberFormat(value) {
				let val = (value / 1)
				return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') //comma separator
			},
			increaseDeposit() {
				let temp = Number(this.depositUsd) + 1
				if (temp <= 0) {
					this.depositUsd = 0
				}else {
					this.depositUsd = temp
				}
			},
			decreaseDeposit() {
				let temp = Number(this.depositUsd) - 1
				if (temp < 0) {
					this.depositUsd = 0
				}else {
					this.depositUsd = temp
				}
			},

			decreaseWithdrawUsd() {
				let temp = Number(this.withdrawUsd) - 1
				if (temp <= 0) {
					this.withdrawUsd = 0
					this.withdrawIdr = 0
				}else {
					this.withdrawUsd = temp
					this.withdrawIdr = temp * this.streamingRate.streamBuy
				}
			},
			increaseWithdrawUsd() {
				let temp = Number(this.withdrawUsd) + 1
				if (temp <= 0) {
					this.withdrawUsd = 0
					this.withdrawIdr = 0
				}else {
					this.withdrawUsd = temp
					this.withdrawIdr = temp * this.streamingRate.streamBuy
				}
			},

			decreaseWithdrawIdr() {
				let temp = Number(this.withdrawIdr) - 10000
				if (temp <= 0) {
					this.withdrawIdr = 0
					this.withdrawUsd = 0
				}else {
					this.withdrawIdr = temp
					this.withdrawUsd = temp / this.streamingRate.streamBuy
				}
			},
			increaseWithdrawIdr() {
				let temp = Number(this.withdrawIdr) + 10000
				if (temp <= 0) {
					this.withdrawIdr = 0
					this.withdrawUsd = 0
				}else {
					this.withdrawIdr = temp
					this.withdrawUsd = temp / this.streamingRate.streamBuy
				}
			},

			increaseReqCreditLimit() {
				let temp = Number(this.reqCreditLimitUSD) + 1
				if (temp <= 0) {
					this.reqCreditLimitUSD = 0
				}else {
					this.reqCreditLimitUSD = temp
				}
			},
			decreaseReqCreditLimit() {
				let temp = Number(this.reqCreditLimitUSD) - 1
				if (temp <= 0) {
					this.reqCreditLimitUSD = 0
				}else {
					this.reqCreditLimitUSD = temp
				}
			},

			increaseQuantityInt(contractId) {
				let holding = this.holdings.find(obj => obj.attributes.contractId == contractId)
				let product = this.products.find(obj => obj.id == contractId)

				let totalGram = Number(Decimal.mul(product.attributes.weightInGram, Decimal.div(holding.attributes.value, product.attributes.weightCorrection)))

				// let temp = new Decimal(this.bullionWithdrawalQuantity[contractId]).add(this.bullionWithdrawalMultiple[contractId])
				let temp = new Decimal(this.bullionWithdrawalQuantity[contractId]).add(1)

				if (temp.greaterThan(totalGram)) {
					// this.bullionWithdrawalQuantity[contractId] = Number(Decimal.mod(totalGram, this.bullionWithdrawalMultiple[contractId]).sub(totalGram))
					this.bullionWithdrawalQuantity[contractId] = totalGram
				}else if (temp.lessThan(0)) {
					this.bullionWithdrawalQuantity[contractId] = 0
				}else {
					this.bullionWithdrawalQuantity[contractId] = Number(temp)
				}
			},
			decreaseQuantityInt(contractId) {
				let holding = this.holdings.find(obj => obj.attributes.contractId == contractId)
				let product = this.products.find(obj => obj.id == contractId)

				let totalGram = Number(Decimal.mul(product.attributes.weightInGram, Decimal.div(holding.attributes.value, product.attributes.weightCorrection)))

				// let temp = new Decimal(this.bullionWithdrawalQuantity[contractId]).sub(this.bullionWithdrawalMultiple[contractId])
				let temp = new Decimal(this.bullionWithdrawalQuantity[contractId]).sub(1)

				if (temp.greaterThan(totalGram)) {
					// this.bullionWithdrawalQuantity[contractId] = Number(Decimal.mod(totalGram, this.bullionWithdrawalMultiple[contractId]).sub(totalGram))
					this.bullionWithdrawalQuantity[contractId] = totalGram
				}else if (temp.lessThan(0)) {
					this.bullionWithdrawalQuantity[contractId] = 0
				}else {
					this.bullionWithdrawalQuantity[contractId] = Number(temp)
				}
			},

			showDeposit() {
				this.depositDisplay = 'block'
				this.withdrawDisplay = 'none'
				this.payrefDisplay = 'initial'
			},
			showWithdraw() {
				this.withdrawDisplay = 'block'
				this.depositDisplay = 'none'
				this.payrefDisplay = 'none'
			},
			reviewCreditChange() {
				Swal.fire({
					background: '#191f31',
					html: '<span style="color: white;"> Syarat dan ketentuan berlaku untuk menggunakan fasilitas ini </span>'
				})
			},
			getDepositWithdrawalHistory() {
				axios({
					method: 'get',
					url:process.env.VUE_APP_BACKEND_URL+'/abx/account/deposit_withdrawal_history'
				}).then(response => {
					let history = response.data.data
					let deposit, withdrawal, debit, credit, dateTemp
					for (let i = 0; i < 10; i++) {
						dateTemp = new Date(history.balance_history[i].attributes.createdAt)
						let date = {
							year: dateTemp.getFullYear(),
							month: (dateTemp.getMonth() + 1 < 10) ? `0${dateTemp.getMonth() + 1}` : dateTemp.getMonth() + 1,
							date: (dateTemp.getDate() < 10) ? `0${dateTemp.getDate()}` : dateTemp.getDate(),
							hours: (dateTemp.getHours() < 10) ? `0${dateTemp.getHours()}` : dateTemp.getHours(),
							minutes: (dateTemp.getMinutes() < 10) ? `0${dateTemp.getMinutes()}` : dateTemp.getMinutes()
						}
						withdrawal = history.withdrawal.find(obj => obj.id == history.balance_history[i].id)
						deposit = history.deposit.find(obj => obj.id == history.balance_history[i].id)
						if (withdrawal) {
							if (this.currency == 'idr') {
								debit = this.numberFormat((withdrawal.attributes.amount * this.streamingRate.streamBuy).toFixed(2))
							}else {
								debit = this.numberFormat(withdrawal.attributes.amount.toFixed(2))
							}
							credit = '-'
						}else {
							debit = '-'
							if (this.currency == 'idr') {
								credit = this.numberFormat((deposit.attributes.amount * this.streamingRate.streamBuy).toFixed(2))
							}else {
								credit = this.numberFormat(deposit.attributes.amount.toFixed(2))
							}
						}
						this.balanceHistory.push({
							date: `${date.year}/${date.month}/${date.date} ${date.hours}:${date.minutes}`,
							debit: debit,
							credit: credit
						})
					}
					console.log('berhasil deposit withdrawal history', response)
				}).catch(error => {
					if (error.response) {
						/*
						 * The request was made and the server responded with a
						 * status code that falls out of the range of 2xx
						 */
						console.log(error.response.data);
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						/*
						 * The request was made but no response was received, `error.request`
						 * is an instance of XMLHttpRequest in the browser and an instance
						 * of http.ClientRequest in Node.js
						 */
						console.log(error.request);
					} else {
						// Something happened in setting up the request and triggered an Error
						console.log(error.message);
					}
					console.log('gagal deposit withdrawal history', error.config);
				})
			},
			reqWithdrawal() {
				let notError = true
				this.withdrawUsdError = []
				if (this.withdrawUsd <= 0) {
					notError = false
					this.withdrawUsdError.push('Value must be greater than 0')
				}
				if (notError) {
					let balanceValidationIsOk = false
					Swal.queue([{
						background: '#191f31',
						title: '<span style="color: white;">Are you sure want to withdraw?</span>',
						showCancelButton: true,
						confirmButtonText: 'Submit',
						showLoaderOnConfirm: true,
						preConfirm: () => {
							balanceValidationIsOk = true
							return true
							// return axios({
							// 	method: 'POST',
							// 	url: process.env.VUE_APP_BACKEND_URL + '/user/balance_validation',
							// 	data: {
							// 		amount_idr: this.totalIdrLimit,
							// 		direction: this.direction
							// 	}
							// }).then(response => {
							// 	balanceValidationIsOk = true
								
							// 	console.log('berhasil balance validation', response, balanceValidationIsOk)
							// }).catch(error => {
							// 	let errorTitle = '<span style="color: white;">Something went wrong</span>'
							// 	let errorText = '<span style="color: white;">Please try again later</span>'

							// 	if (error.response) {
							// 		/*
							// 		 * The request was made and the server responded with a
							// 		 * status code that falls out of the range of 2xx
							// 		 */
							// 		console.log(error.response.data);
							// 		console.log(error.response.status);
							// 		console.log(error.response.headers);
									
							// 		errorTitle = '<span style="color: white;">Something went wrong</span>'
							// 		errorText = '<span style="color: white;">' + error.response.data.message + '</span>'
							// 	} else if (error.request) {
							// 		/*
							// 		 * The request was made but no response was received, `error.request`
							// 		 * is an instance of XMLHttpRequest in the browser and an instance
							// 		 * of http.ClientRequest in Node.js
							// 		 */
							// 		console.log(error.request);

							// 		errorTitle = '<span style="color: white;">Server appears to be offline</span>'
							// 		errorText = '<span style="color: white;">Please try again later</span>'
							// 	} else {
							// 		// Something happened in setting up the request and triggered an Error
							// 		console.log(error.message);
							// 	}
							// 	Swal.insertQueueStep({
							// 		background: '#191f31',
							// 		type: 'error',
							// 		title: errorTitle,
							// 		html: errorText
							// 	})
							// 	console.log('Gagal balance validation', error.config)
							// })
						},
						onAfterClose: () => {
							if (balanceValidationIsOk) {
								Swal.showLoading()
								axios({
									method: 'post',
									url:process.env.VUE_APP_BACKEND_URL+'/abx/req_withdrawal',
									data: {
										amount_usd: (this.withdrawUsd),
										amount_idr: (this.withdrawUsd * this.streamingRate.streamBuy), 
										description: this.withdrawDescription
									}
								}).then(response => {
									Swal.hideLoading()
									Swal.fire({
										background: '#191f31',
										type: 'success',
										title: '<span style="color: white;">Transfer success</span>'
									})
									console.log('berhasil req withdrawal', response)
								}).catch(error => {
									Swal.hideLoading()
									let errorTitle = '<span style="color: white;">Something went wrong</span>'
									let errorText = '<span style="color: white;">Please try again later</span>'

									if (error.response) {
										/*
										 * The request was made and the server responded with a
										 * status code that falls out of the range of 2xx
										 */
										console.log(error.response.data);
										console.log(error.response.status);
										console.log(error.response.headers);
										
										errorTitle = '<span style="color: white;">Something went wrong</span>'
										errorText = '<span style="color: white;">' + error.response.data.message + '</span>'
									} else if (error.request) {
										/*
										 * The request was made but no response was received, `error.request`
										 * is an instance of XMLHttpRequest in the browser and an instance
										 * of http.ClientRequest in Node.js
										 */
										console.log(error.request);

										errorTitle = '<span style="color: white;">Server appears to be offline</span>'
										errorText = '<span style="color: white;">Please try again later</span>'
									} else {
										// Something happened in setting up the request and triggered an Error
										console.log(error.message);
									}
									Swal.fire({
										background: '#191f31',
										type: 'error',
										title: errorTitle,
										html: errorText
									})
									console.log('gagal req withdrawal', error);
								})
							}
						}
					}])
				}
			},

			setBullionWithdrawal() {
				const contractOrder = this.bullionWithdrawalOrder
				const products = this.products
				const holdings = this.holdings
				let temp = []

				for (let i = 0; i < contractOrder.length; i++) {
					if (products && holdings) {
						let product = products.find(obj => obj.id == contractOrder[i])
						let holding = holdings.find(obj => obj.attributes.contractId == contractOrder[i])
						if (product && holding) {
							temp.push({
								contractId: contractOrder[i],
								status: product.attributes.contractStatusId,
								product: product.attributes.name,
								quantity: Number(Decimal.div(holding.attributes.value, product.attributes.weightCorrection)),
								weight: product.attributes.weightInGram,
								weightCorrection: product.attributes.weightCorrection,
								totalGram: Number(Decimal.mul(product.attributes.weightInGram, Decimal.div(holding.attributes.value, product.attributes.weightCorrection)))
							})
						}else {
							temp.push({
								contractId: contractOrder[i],
								status: 'disabled',
								product: '-',
								quantity: 0,
								weight: 0,
								weightCorrection: 1,
								totalGram: 0,
							})
						}
					}else {
						temp.push({
							contractId: contractOrder[i],
							status: 'disabled',
							product: '-',
							quantity: 0,
							weight: 0,
							weightCorrection: 1,
							totalGram: 0,
						})
					}
				}

				this.totalGold = temp
			},

			showWithdrawDestination() {
				this.withdrawDestinationIsOpen = true
			},
			withdrawDestinationAfterClose(value) {
				if (value == 'giropos') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/pos-giro.png`
				}else if (value == 'gopay') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-gopay-2.jpg`
				}else if (value == 'ovo') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-ovo-3.jpg`
				}else if (value == 'rekpon' || value == 'cimb') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-cimb-3.png`
				}else if (value == 'linkaja') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-linkaja.png`
				}else if (value == 'dana') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-dana-2.png`
				}else if (value == 'isaku') { //isaku
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-isaku.jpg`
				}else if (value == 'bca') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-bca-2.png`
				}else if (value == 'mandiri') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-mandiri-3.png`
				}else if (value == 'bni') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-bni-2.png`
				}else if (value == 'Artha Graha') {
					this.withdrawDestinationLogo = `${this.publicPath}assets/img/logo-bagi-removebg.png`
					this.withdrawDestinationAccountNumber = this.paymentInfo.utility_account[1].account_number
				}

				if (value != '') {
					this.withdrawDestination = value
				}
				
				this.withdrawDestinationIsOpen = false
			},

			countTotalCharges() {
				const destination = this.selectedDestination

				if (!destination) {
					Swal.fire({
						background: '#191f31',
						html: '<span style="color: white;">Please select the pick up location!</span>'
					})
				}else if (this.bullionWithdrawalTotalQuantity <= 0 || this.bullionWithdrawalTotalWeight <= 0) {
					Swal.fire({
						background: '#191f31',
						html: '<span style="color: white;">Quantity and weight must be greater than zero!</span>'
					})
				}
				// else if ((this.quantity5Gram*5 + this.quantity10Gram*10) > (this.totalGold[0].quantity + this.totalGold[1].quantity) || this.quantity100Gram*100 > this.totalGold[2].quantity || this.quantity1Kg*1000 > this.totalGold[4].quantity || this.quantity1Kg*1000 > this.totalGold[5].quantity) {
				// 	if ((this.quantity5Gram*5 + this.quantity10Gram*10) > (this.totalGold[0].quantity + this.totalGold[1].quantity)) {
				// 		Swal.fire({
				// 			background: '#191f31',
				// 			html: '<span style="color: white;">You don\'t have enough 0.01 gram pool and 1 gram pool gold</span>'
				// 		})
				// 	}else if (this.quantity100Gram*100 > this.totalGold[2].quantity) {
				// 		Swal.fire({
				// 			background: '#191f31',
				// 			html: '<span style="color: white;">You don\'t have enough 100 gram non-pool gold</span>'
				// 		})
				// 	}else if (this.quantity1Kg*1000 > this.totalGold[4].quantity) {
				// 		Swal.fire({
				// 			background: '#191f31',
				// 			html: '<span style="color: white;">You don\'t have enough 1 kg non-pool gold</span>'
				// 		})
				// 	}else if (this.quantity1Kg*1000 > this.totalGold[5].quantity) {
				// 		Swal.fire({
				// 			background: '#191f31',
				// 			html: '<span style="color: white;">You don\'t have enough 10 kg non-pool gold</span>'
				// 		})
				// 	}
				// }
				else {
					this.apiStatusGetFee = 'loading'
					this.apiStatusGetPostalCode = 'loading'
					let statusCheck = 0

					axios({
						method: 'POST',
						url:process.env.VUE_APP_BACKEND_URL+'/poslog/get/fee',
						data: {
							shipperzipcode: "10710",
							receiverzipcode: destination.location_id,
							weight: this.bullionWithdrawalTotalWeight,
							valuegoods: this.valueGoods
						}
					}).then(response => {
						let temp = response.data.data
						if (Array.isArray(temp)) {
							let temp2 = response.data.data.find(obj => obj.serviceCode == 'PVG')
							if (temp2) {
								this.feeGetFee = temp2.fee
								this.feeTaxGetFee = temp2.feeTax
								this.insuranceGetFee = temp2.insurance
								this.insuranceTaxGetFee = temp2.insuranceTax

								//search arrival estimation in string
								let index1 = -1 //index for 'hari'||'minggu'
								let index2 = -1 //index for '('
								let serviceName = temp2.serviceName.toLowerCase()
								let multiplier = 1
								if (serviceName.search("hari")) {
									index1 = serviceName.search("hari")
								}else {
									index1 = serviceName.search("minggu")
									multiplier = 7
								}
								let stopLoop = false
								let counter = 1
								while(!stopLoop) {
									if (serviceName[index1 - counter++] == '(') {
										index2 = index1 - --counter
										stopLoop = true
									}
								}
								let arrivalEst = serviceName.substring(index2+1, index1-1) * multiplier
								let orderDate = new Date(this.bullionWithdrawalOrderDate)
								let arrivalEstDate = orderDate.getDate() + arrivalEst
								let arrivalDate = new Date(new Date(orderDate).setDate(arrivalEstDate)).toISOString().slice(0,10)
								this.bullionWithdrawalArrivalDate = arrivalDate

								statusCheck++
								if (statusCheck == 2) {
									this.isBullionWithdrawalTotalChargesCounted = true
								}
							}else {
								Swal.fire({
									background: '#191f31',
									type: 'error',
									title: '<span style="color: white;">Failed!</span>',
									html: '<span style="color: white;">Please select another location</span>'
								})	
							}
						}else {
							Swal.fire({
								background: '#191f31',
								type: 'error',
								title: '<span style="color: white;">Failed!</span>',
								html: '<span style="color: white;">Please select another location.</span>'
							})
						}

						this.apiStatusGetFee = 'success'
						console.log('berhasil get fee', response, temp, destination)
					}).catch(error => {
						this.apiStatusGetFee = 'error'
						if (error.response) {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */
							console.log(error.response.data);
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							/*
							 * The request was made but no response was received, `error.request`
							 * is an instance of XMLHttpRequest in the browser and an instance
							 * of http.ClientRequest in Node.js
							 */
							console.log(error.request);
						} else {
							// Something happened in setting up the request and triggered an Error
							console.log(error.message);
						}
						console.log('gagal get fee', error.config);
					})

					axios({
						method: 'POST',
						url:process.env.VUE_APP_BACKEND_URL+'/poslog/get/postal_code',
						data: {
							city: destination.location_name,
							address: destination.address
						}
					}).then(response => {
						this.postalCode = response.data.data[0]
						
						statusCheck++
						if (statusCheck == 2) {
							this.isBullionWithdrawalTotalChargesCounted = true
						}
						this.apiStatusGetPostalCode = 'success'
						console.log('berhasil postal code', response, this.gold100gr, this.valuegoods)
					}).catch(error => {
						this.apiStatusGetPostalCode = 'error'
						if (error.response) {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */
							console.log(error.response.data);
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							/*
							 * The request was made but no response was received, `error.request`
							 * is an instance of XMLHttpRequest in the browser and an instance
							 * of http.ClientRequest in Node.js
							 */
							console.log(error.request);
						} else {
							// Something happened in setting up the request and triggered an Error
							console.log(error.message);
						}
						console.log('gagal postal code', error.config);
					})
				}
			},

			submitBullionWithdrawal() {
				const temporary = 1
				const destination = this.selectedDestination
				if (temporary) {
					Swal.fire({
	          background: '#191f31',
	          // title: '<span style="color: white;">This feature will available soon.</span>',
	          html: '<span style="color: white;">This feature will be available soon.</span>'
	        })
				}
				else if (this.bullionWithdrawalTotalQuantity <= 0 || this.bullionWithdrawalTotalWeight <= 0) {
					Swal.fire({
						background: '#191f31',
						html: '<span style="color: white;">Quantity and weight must be greater than zero!</span>'
					})
				}else if (!destination) {
					Swal.fire({
						background: '#191f31',
						html: '<span style="color: white;">Please select the pick up location!</span>'
					}).then(() => {
						setTimeout(function() { document.getElementById('location').focus() }, 280); 
					})
				}else if (this.disclaimerHasBeenRead) {

					let contractId = []
					let contractQuantity = []

					let metalInfo = []
					for( let el in this.bullionWithdrawalQuantity ) {
						let product = this.products.find(obj => obj.id == el)
						if (product.attributes.contractStatusId == 'disabled') {
							continue
						}

						let metalInfoTemp = {
							"contract_id" : el,
							"metal_type" : "gold",
							"unit" : "gr",
							"quantity" : Decimal.div(this.bullionWithdrawalMultiple[el], Decimal.div(product.attributes.weightInGram, product.attributes.weightCorrection)),
							"weight" : this.bullionWithdrawalMultiple[el]
						}

						let loop = Number(Decimal.mul(this.bullionWithdrawalQuantity[el], product.attributes.weightInGram).div(this.bullionWithdrawalMultiple[el]))
						for (let i = 0; i < loop; i++) {
							metalInfo.push(metalInfoTemp)
						}

						if( this.bullionWithdrawalQuantity.hasOwnProperty( el ) ) {
							let gold = this.totalGold.find(obj => obj.contractId == el)
							contractId.push(el)
							contractQuantity.push(Decimal.mul(this.bullionWithdrawalQuantity[el], gold.weightCorrection))
						}
					}

					Swal.queue([{
						background: '#191f31',
						title: '<span style="color: white;">Are you sure want to submit?</span>',
						showCancelButton: true,
						confirmButtonText: 'Submit',
						showLoaderOnConfirm: true,
						preConfirm: () => {
							return axios({
								method: 'POST',
								url: process.env.VUE_APP_BACKEND_URL+'/poslog/request_withdrawal',
								data: {
									"location_id": destination.location_id,
									"description": this.bullionWithdrawalDescription,
									"metal_info": metalInfo,

									// branch_address: destination.address,
									// branch_city: destination.location_name,
									// branch_zipcode: this.postalCode,
									// quantity: this.bullionWithdrawalTotalQuantity,
									// value: this.valueBullionWithdrawal,
									// valuegoods: this.valueGoods,
									// weight: this.bullionWithdrawalTotalWeight,
									// delivery_cost: this.deliveryCost, //fee from get fee api = delivery cost
									// fee_taxes: this.feeGetFee,
									// insurance: this.insuranceGetFee,
									// insurance_taxes: this.insuranceTaxGetFee,
									// total_charge : Number(this.bullionWithdrawalTotalCharges),
									// withdrawal_date : Date.now(),
									// contract_id : contractId,
									// contract_quantity : contractQuantity,
								}
							})
							.then(response => {
								// const temp = response.data.data.body
								Swal.insertQueueStep({
									background: '#191f31',
									type: 'success',
									title: '<span style="color: white;">Request Withdrawal Success!</span>',
									// title: '<span style="color: white;">Receipt Number:</span>',
									// html: '<span style="color: white;">'+ temp.transref +'</span>',
									onAfterClose: () => {
										//reset bullion withdarwal form and go to track bullion
										this.bullionWithdrawalQuantity = {
											'1': 0,
											'2': 0,
											'3': 0,
											'4': 0,
											'5': 0,
											'6': 0,
										}
										this.destination = ''
										this.bullionWithdrawalArrivalDate = ''
										this.$refs.trackBullion.getListBullionWithrawal()
										this.disclaimerHasBeenRead = false
										document.getElementById("track-bullion").click()
									}
								})
								console.log('berhasil add posting doc', response)

							})
							.catch(error => {
								let errorTitle = '<span style="color: white;">Something went wrong</span>'
								let errorText = '<span style="color: white;">Please try again later</span>'

								if (error.response) {
									/*
									 * The request was made and the server responded with a
									 * status code that falls out of the range of 2xx
									 */
									console.log(error.response.data);
									console.log(error.response.status);
									console.log(error.response.headers);
									
									errorTitle = '<span style="color: white;">Something went wrong</span>'
									errorText = '<span style="color: white;">' + error.response.data.message + '</span>'
								} else if (error.request) {
									/*
									 * The request was made but no response was received, `error.request`
									 * is an instance of XMLHttpRequest in the browser and an instance
									 * of http.ClientRequest in Node.js
									 */
									console.log(error.request);

									errorTitle = '<span style="color: white;">Server appears to be offline</span>'
									errorText = '<span style="color: white;">Please try again later</span>'
								} else {
									// Something happened in setting up the request and triggered an Error
									console.log(error.message);
								}
								Swal.insertQueueStep({
									background: '#191f31',
									type: 'error',
									title: errorTitle,
									html: errorText
								})
								console.log('Gagal add posting doc', error.config)
							})
						}
					}])
				}else {
					Swal.fire({
						background: '#191f31',
						html: '<span style="color: white;">Please read the Disclaimer first!</span>'
					})
				}
				// Swal.fire({
				// 	background: '#191f31',
				// 	html: '<span style="color: white;">Under development &#9786;</span>'
				// })
			},
			showDisclaimer() {
				this.disclaimerIsOpen = true
			},
			disclaimerAfterClose(value) {
				this.disclaimerIsOpen = false
				if (value == 'agree') {
					this.disclaimerHasBeenRead = true
				}
			}
		}
	}
</script>

<style scoped>
	/* Chrome, Safari, Edge, Opera */
	.c-hide-spinner::-webkit-outer-spin-button,
	.c-hide-spinner::-webkit-inner-spin-button {
			/* display: none; <- Crashes Chrome on hover */
			-webkit-appearance: none;
			margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
	}
	/* Firefox */
	.c-hide-spinner[type=number] {
			-moz-appearance:textfield;
	}

	.c-decrease-button, .c-increase-button {
		padding-right: 15px !important;
		padding-left: 15px !important;
		text-align: center;
		transition: 0s;

		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		 -khtml-user-select: none; /* Konqueror HTML */
			 -moz-user-select: none; /* Firefox */
				-ms-user-select: none; /* Internet Explorer/Edge */
						user-select: none; /* Non-prefixed version, currently
																	supported by Chrome and Opera */
	}
	.c-decrease-button:hover, .c-increase-button:hover {
		cursor: pointer;
	}
	.c-decrease-button:active, .c-increase-button:active {
		background-color: white;
		color: black;
	}
	.c-decrease-button {

	}
	.c-increase-button {
		border-left: 1px solid #2b3553;
	}

	#myProgress {
		position: relative;
		width: 100%;
		background-color: #4CAF50;
	}
	#myBar {
		width: 0%;
		height: 30px;
		background-color: #ddd;
		text-align: center;
		color: white;
	}
	#frontBar {
		position: absolute;
		top: 0;
		color: black;
		background-color: transparent;
		width: 100%;
		text-align: center;
		line-height: 30px;
		font-weight: bold;
	}

	input.c-disabled {
		color: rgb(255, 255, 255, 0.8);
	}

	.c-input-group-text {
		font-size: 12px;
	}

	.c-select {
		background-color: #27293d;
		border: 1px solid #2b3553;
	}

	.c-description {
		width: 300px;
		max-width: 300px;
	}

	.button-counter {
		background-color: #1E1E2E;
	}

	.c-input {
		margin: 0 2px;
		padding: 0 8px;
		border: 1px solid #2b3553;
		background: transparent;
		height: 26.4px;
		border-radius: 4px;
		text-align: center;
		width: 80px;
		min-width: 80px;
		color: white;
	}

	.bullion-withdrawal-description {
		border: 1px solid #2b3553;
		padding: 12px;
		font-size: 12px;
	}

	.table-bullion-withdrawal th{
		padding: 12px 24px;
	}

	.table-bullion-withdrawal {
		width: auto;
		/*background-color: #212529;*/
	}

	.table-bullion-withdrawal .first-head {
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	}

</style>
